import React, { Component } from 'react'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect
} from "react-router-dom";
import Customer from './Customer';
import TimeRegistration from '../container/TimeRegistration';
import Leads from '../container/Leads';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import ZoomOutIcon from '@material-ui/icons/ZoomOut';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import { Button } from '@material-ui/core';
import { connect } from 'react-redux';
import { LogoutAction, OnFirstLoginChange } from '../actions'
import UserCategories from '../container/UserCategories';
import Branch from '../container/Branches'
import ConsultantFunction from '../container/ConsultantFunction';
import Themen from '../container/Themen';
import Land from '../container/Land';
import Classifications from '../container/Classifications'
import System from '../container/Systems/'
import PublicHoliday from '../container/PublicHoliday';
import Users from '../container/Users';
import Projects from '../container/Projects';
import Archive from '../container/Archive';
import MontPlans from '../container/MonthPlan';
import Beraterplan from '../container/Beraterplan';
import OverviewPDF from '../container/OverviewReports';
import VacationOverview from '../container/VacationOverview';
import NoMatchPage from './NoMatchPage';
import { Document, Page } from "react-pdf/dist/entry.webpack";
import isEmpty from 'lodash.isempty';
import ResourcePlanning from '../container/ResourcePlanning';

class Auth extends Component {
  state = {
    numPages: null,
    pageNumber: 1,
    scale: 1.5,
    disagree: false
  }

  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ numPages });
  };
  onPageLoad = (page) => {
    const parentDiv = document.querySelector('#pdfDocument')
    let pageScale = parentDiv.clientWidth / page.originalWidth
    if (this.state.scale !== pageScale) {
      this.setState({ scale: pageScale });
    }
  }

  render() {
    const { scale, pageNumber, numPages, disagree } = this.state
    const { dataDeclerationPdf } = this.props
    const access_rights = JSON.parse(localStorage.getItem('access_right'))
    const token = localStorage.getItem('access-token')
    if (token === null) {
      this.props.LogoutAction()
    }
    return (
      <div>

        <Dialog
          open={disagree}
        >
          <DialogContent>
            <DialogContentText >
              Sie müssen die Sicherheitsrichtlinie der Lischke Consulting GmbH akzeptieren, um fortzufahren              </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Link className="text-white" to="/" onClick={() => {
              localStorage.setItem("is_first_login", true);
              this.props.LogoutAction();
            }}>
              <Button variant="outlined" className="m-10">
                ok
              </Button>
            </Link>
          </DialogActions>
        </Dialog>


        <Dialog
          className="dialogFirst"
          maxWidth='lg'
          aria-labelledby="simple-dialog-title" open={this.props.user.is_first_login === true ? true : false}>
          <DialogTitle id="simple-dialog-title">IT-Sicherheitsrichtlinie</DialogTitle>
          <DialogContent>
            {!isEmpty(dataDeclerationPdf) &&
              <div id="pdfDocument" className="declerationPDf">
                <ZoomInIcon onClick={() => { if (scale <= 3) this.setState({ scale: scale + 0.25 }) }}
                >Zoom in</ZoomInIcon>
                <ZoomOutIcon onClick={() => {
                  if (scale > 1.5) this.setState({ scale: scale - 0.25 })
                }}
                >Zoom out</ZoomOutIcon>
                <div className="pagination">
                  <NavigateBeforeIcon onClick={() => { if (pageNumber > 1) this.setState({ pageNumber: pageNumber - 1 }) }} />
                  <span>{pageNumber}</span>
                  <span>/{numPages}</span>
                  <NavigateNextIcon onClick={() => { if (pageNumber < numPages) this.setState({ pageNumber: pageNumber + 1 }) }} />
                </div>
                <Document
                  file={dataDeclerationPdf}
                  onLoadSuccess={this.onDocumentLoadSuccess}
                >
                  <Page
                    onLoadSuccess={this.onPageLoad}
                    pageNumber={pageNumber}
                    scale={scale} />
                </Document>
              </div>
            }
          </DialogContent>
          <div className="actionBtn ma0">
            {!isEmpty(dataDeclerationPdf) &&
              <Button variant="outlined" color="primary"
                style={{ marginLeft: "80px", marginBottom: "10px", marginRight: "10px" }}
                onClick={() => {
                  const theLink = document.createElement('a');
                  theLink.href = dataDeclerationPdf;
                  theLink.download = "Lischke Consulting - Sicherheitsrichtlinie.pdf";
                  document.body.appendChild(theLink);
                  theLink.click();
                  document.body.removeChild(theLink);
                }
                }
              >PDF speichern</Button>
            }
            <Link className="text-white" to="/" onClick={() => {
              const user = JSON.parse(localStorage.getItem('user'))
              localStorage.setItem("is_first_login", false);
              this.props.OnFirstLoginChange(user.id);
            }}>
              <Button variant="outlined" color="primary" className="m-10">
                Ich bestätige
          </Button>
            </Link>
            <Link className="text-white" to="/" onClick={() => {
              this.setState({ disagree: true })
            }}>
              <Button variant="outlined" color="secondary" className="m-10">
                Ich bestätige nicht
              </Button>
            </Link>
          </div>
        </Dialog>
        <Route exact path="/">
          {this.props.user.is_first_login === false &&
            <Redirect to="/consultant_plan" />
          }
        </Route>
        {Number(access_rights.users) !== 0 &&
          <Route path="/users">
            <Users />
          </Route>
        }
        {Number(access_rights.user_categories) !== 0 &&
          <Route path="/user_categories">
            <UserCategories />
          </Route>
        }
        {Number(access_rights.consultant_functions) !== 0 &&
          <Route path="/consultant_functions">
            <ConsultantFunction />
          </Route>
        }
        {Number(access_rights.classifications) !== 0 &&
          <Route path="/classifications">
            <Classifications />
          </Route>
        }
        {Number(access_rights.branches) !== 0 &&
          <Route path="/branches">
            <Branch />
          </Route>
        }
        {Number(access_rights.themes) !== 0 &&
          <Route path="/themes">
            <Themen />
          </Route>
        }
        {Number(access_rights.countries) !== 0 &&
          <Route path="/countries">
            <Land />
          </Route>
        }
        {Number(access_rights.public_holidays) !== 0 &&
          <Route path="/public_holidays">
            <PublicHoliday />
          </Route>
        }
        {Number(access_rights.system_settings) !== 0 &&
          <Route path="/system_settings">
            <System />
          </Route>
        }
        {Number(access_rights.months_plan) !== 0 &&
          <Route path="/6_month_plan">
            <MontPlans />
          </Route>
        }
        {(Number(access_rights.consultant_plan) !== 0 || Number(access_rights.consultant_plan_for_own) !== 0) &&
          <Route path="/consultant_plan">
            <Beraterplan />
          </Route>
        }
        {Number(access_rights.year_overview_customers) !== 0 &&
          <Route path="/year_overview_customers">
            <OverviewPDF pdf="Jahresübersicht_Kunden_" />
          </Route>
        }
        {Number(access_rights.year_overview_projects) !== 0 &&
          <Route path="/year_overview_projects">
            <OverviewPDF pdf="Jahresübersicht_Projekte_" />
          </Route>
        }
        {Number(access_rights.year_overview_consultants) !== 0 &&
          <Route path="/year_overview_consultants">
            <OverviewPDF pdf="Jahresübersicht_Berater_" />
          </Route>
        }
        {Number(access_rights.year_overview_students) !== 0 &&
          <Route path="/year_overview_students">
            <OverviewPDF pdf="Jahresübersicht_Studenten_" />
          </Route>
        }
        {Number(access_rights.year_overview_themes) !== 0 &&
          <Route path="/year_overview_themes">
            <OverviewPDF pdf="Jahresübersicht_Themen_" />
          </Route>
        }
        {Number(access_rights.year_overview_leads) !== 0 &&
          <Route path="/year_overview_leads">
            <OverviewPDF pdf="Jahresübersicht_Leads_" />
          </Route>
        }
        {Number(access_rights.year_overview_vacation) !== 0 &&
          <Route path="/vacation_overview">
            <VacationOverview />
          </Route>
        }
        {Number(access_rights.archive) !== 0 &&
          <Route path="/archive">
            <Archive />
          </Route>
        }
        {Number(access_rights.customers) !== 0 &&
          <Route path="/customer">
            <Customer />
          </Route>
        }
        {(Number(access_rights.projects_basedata_for_other) !== 0 || Number(access_rights.projects_basedata_for_own) !== 0 || Number(access_rights.projects_capacity_for_other) !== 0 ||
          Number(access_rights.projects_capacity_for_own) !== 0 || Number(access_rights.projects_consultants_for_other) !== 0 ||
          Number(access_rights.projects_consultants_for_own) !== 0 || Number(access_rights.projects_fee_for_other) !== 0 ||
          Number(access_rights.projects_invoices_for_other) !== 0 || Number(access_rights.projects_invoices_for_own) !== 0 ||
          Number(access_rights.projects_activity_for_other) !== 0 || Number(access_rights.projects_activity_for_own) !== 0 ||
          Number(access_rights.projects_planning_for_own) !== 0 || Number(access_rights.projects_planning_for_other) !== 0) &&
          <Route path="/projects/:projectno?">
            <Projects />
          </Route>
        }
        {(Number(access_rights.time_reg_for_own) !== 0 || Number(access_rights.time_reg_other_consultants_other) !== 0) &&
          <Route path="/time_registration">
            <TimeRegistration />
          </Route>
        }
        {Number(access_rights.year_overview_resource_planning) !== 0 &&
          <Route path="/resource_planning">
            <ResourcePlanning />
          </Route>
        }
        {/*{Number(access_rights.leads) !== 0 &&*/}
        <Route path="/list_of_leads">
          <Leads />
        </Route>
        {/*}*/}
        {/* <Route component={NoMatchPage} />*/}
      </div>)
  }
}

const mapStateToProps = state => {
  const { is_first_login, current_route } = state.routing;
  const { user } = state.login;
  const { dataDeclerationPdf } = state.systems

  return {
    is_first_login,
    current_route,
    user,
    dataDeclerationPdf
  }
}
const mapDispatchToProps = dispatch => {
  return {
    OnFirstLoginChange: (id) => dispatch(OnFirstLoginChange(id)),
    LogoutAction: () => dispatch(LogoutAction()),

  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Auth);